import { MDBCol, MDBContainer, MDBRow } from "mdb-react-ui-kit";
import Image, { StaticImageData } from "next/image";
import {
    forwardRef,
    ReactElement,
    ReactNode,
    RefObject,
    useEffect,
} from "react";
import adventuresPic from "../../public/images/adventures_box.png";
import discoverPic from "../../public/images/discover_box.png";
import expertPic from "../../public/images/expert_box.png";
import { whyChoosePlayTitle } from "../../utils/mockData/detailMocks";
import styles from "../../styles/detail/Detail.WhyChoosePlay.module.scss";
import { randomUid } from "../../utils/randomIds";
import SectionTitle from "../common/SectionTitle";
import { ISectionTitle } from "../../models/common/common";
import { useStore } from "../../store";
import useOnScreen from "../../utils/hooks/useOnScreen";
import { EDetailSection } from "../../models/common/enums";

interface WhyChoosePlayData {
    id: string;
    image: StaticImageData;
    title: string | ReactNode;
    description: string | ReactNode;
}

const WhyChoosePlay = forwardRef<HTMLDivElement>((_, ref): ReactElement => {
    const dispatch = useStore(state => state.dispatchPackage);

    const isOnScreen = useOnScreen(ref as RefObject<HTMLDivElement>);

    const data: WhyChoosePlayData[] = [
        {
            id: randomUid(),
            image: expertPic,
            title: "Italian Expertise",
            description: (
                <>
                    You will receive a{" "}
                    <strong>guided tour by someone who loves,</strong> lives and
                    breathes this Country.
                </>
            ),
        },
        {
            id: randomUid(),
            image: discoverPic,
            title: (
                <>
                    Discover Italy <br />
                    in a Premium Way
                </>
            ),
            description: (
                <>
                    Seamless{" "}
                    <strong>
                        private transfers, handpicked accommodations, curated
                        experiences.
                    </strong>
                </>
            ),
        },
        {
            id: randomUid(),
            image: adventuresPic,
            title: "Crafted for You",
            description: (
                <>
                    Let us craft a{" "}
                    <strong>
                        bespoke itinerary inspired by your travel dreams,
                    </strong>{" "}
                    or explore our curated selection.
                </>
            ),
        },
    ];

    const title: ISectionTitle = {
        title: whyChoosePlayTitle,
        titleColumnSize: 12,
        spaceBetween: 2,
        alignment: "justify-content-center text-center",
        classNameContainer: "py-3",
    };

    useEffect(() => {
        if (isOnScreen) {
            dispatch({
                type: "SET_CURRENT_SECTION",
                payload: EDetailSection.HIW,
            });
        }
    }, [isOnScreen]);

    return (
        <MDBContainer ref={ref} fluid className="py-5 px-0">
            <MDBRow className="d-flex justify-content-center">
                <MDBCol size={10} className="d-flex justify-content-center">
                    <SectionTitle sectionTitle={title} />
                </MDBCol>
            </MDBRow>
            <MDBRow className="d-flex justify-content-center">
                <MDBCol size={10} lg={12} xl={10}>
                    <MDBRow className="justify-content-evenly mx-2 mx-lg-0">
                        {data.map(el => (
                            <MDBCol
                                key={el.id}
                                size={12}
                                lg={3}
                                className="m-1 m-lx-2 rounded-7 d-flex flex-column  justify-content-center"
                            >
                                <MDBRow>
                                    <div className="position-relative w-100 h-100 text-center">
                                        <Image
                                            src={el.image}
                                            alt={
                                                typeof el.title === "string"
                                                    ? el.title
                                                    : "Discover Italy in a Premium Way"
                                            }
                                        />
                                    </div>
                                </MDBRow>
                                <MDBRow
                                    className={`${styles.title} justify-content-center text-center`}
                                >
                                    <div>{el.title}</div>
                                </MDBRow>
                                <MDBRow
                                    className={`${styles.description} justify-content-center text-center`}
                                >
                                    {el.description}
                                </MDBRow>
                            </MDBCol>
                        ))}
                    </MDBRow>
                </MDBCol>
            </MDBRow>
        </MDBContainer>
    );
});

export default WhyChoosePlay;
